import { useUpdateEffect } from '@cian/react-utils';

import { useFiltersSelector } from 'shared/store/clientSide/slices/jsonQuery';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { useMapConfigurationSelector } from 'shared/store/clientSide/slices/mapConfiguration';
import { useGetClustersQuery } from 'shared/store/serverSide/commercial-listing-map/desktop/v2/map/get-clusters/query';

export function useGetClustersOnZoomOrCenterChange(): void {
  const { zoom, center } = useMapConfigurationSelector();
  const filters = useFiltersSelector();
  const isShortListing = useListingLayoutIsShortSelector();

  const { refetch } = useGetClustersQuery();

  useUpdateEffect(() => {
    if (isShortListing) {
      refetch();
    }
    /**
     * center[0], center[1] - проверяем именно значения координат центра на изменение,
     * проверять переменную "center" неправильно
     * filters - на изменение фильтров также перезапрашиваем данные кластеров
     */
  }, [zoom, center[0], center[1], filters]);
}
